import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import TitlePage from 'components/TituloPage';
import Button from 'components/Button';
import { cadastroContribuinte, homeContribuinte } from 'routes/paths';
import { changeInput } from 'utils/formUtils';
import { editDadosCadastraisInput, sucessoRequerimento } from '../submitForm';
import { isValidForSubmit } from '../validations';
import FormDadosCadastrais from 'containers/Forms/FormDadosCadastrais';
import * as S from '../styles';
import * as Style from 'components/Style';
import { ENUM_TIPO_PESSOA } from 'utils/consts';
import { fetchGetDadosCadastrais } from 'store/fetchActions/fetchDadosCadastrais';
import { duckDadosCadastraisDetalhar } from 'store/ducks/dadosCadastrais';
import { formatterDadosCadastraisBackToFront } from 'utils/formatter/dadosCadastrais';

export default function PageDadosCadastraisEditar() {
  const dispatch = useDispatch();
  const history = useHistory();

  const user = useSelector(state => state.sefaz.userProfile);
  const dadosCadastraisDetalhar = useSelector(state => state.dadosCadastrais.dadosCadastraisDetalhar);

  const [loadingEnviar, setLoadingEnviar] = React.useState(false);

  const {
    control,
    setValue,
    getValues,
    watch,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: dadosCadastraisDetalhar,
  });

  React.useEffect(() => {
    if (!dadosCadastraisDetalhar) {
      dispatch(fetchGetDadosCadastrais()).then(pessoas => {
        if (pessoas?.length > 0) {
          dispatch(duckDadosCadastraisDetalhar(formatterDadosCadastraisBackToFront(pessoas)));
          reset(formatterDadosCadastraisBackToFront(pessoas));
        } else {
          history.push(cadastroContribuinte);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === 'tipoPessoa') {
      if (value === ENUM_TIPO_PESSOA.juridica.descricao) {
        const isValid = dispatch(isValidForSubmit(getValues(), setError));
        if (!isValid) return;
      }
      if (!getValues('enderecoPj.cep') && value === ENUM_TIPO_PESSOA.juridica.descricao)
        setValue('enderecoPj', getValues('enderecoPf'));
    }
    changeInput(e, setValue, errors, setError);
  };

  const onSubmit = data => {
    setLoadingEnviar(true);
    dispatch(editDadosCadastraisInput(data, user))
      .then(respostaApi => sucessoRequerimento(respostaApi, history, dispatch))
      .finally(() => setLoadingEnviar(false));
  };

  const onSendFormulario = () => {
    const values = getValues();
    const isValid = dispatch(isValidForSubmit(values, setError));

    if (isValid) {
      onSubmit(values);
    }
  };

  return (
    <S.Contain className="boxShadow">
      <TitlePage textTitle={'DADOS CADASTRAIS - EDITAR'} backPage={homeContribuinte} />
      <form>
        <Style.GlobalCard>
          <FormDadosCadastrais
            control={control}
            onChange={handleChange}
            errors={errors}
            setValue={setValue}
            getValues={getValues}
            watch={watch}
            setError={setError}
          />
        </Style.GlobalCard>
        <S.ContainButton>
          <Button
            text={'Enviar'}
            clickAction={onSendFormulario}
            css={{ margin: '7px 0px 7px auto' }}
            loading={loadingEnviar}
          />
        </S.ContainButton>
      </form>
    </S.Contain>
  );
}
